const VALUES = [
  {
    icon: 'ri-shield-check-line',
    title: 'Segurança Primeiro',
    desc: 'Protegemos seus dados e sua rede com as melhores práticas do mercado e equipamentos certificados.',
  },
  {
    icon: 'ri-time-line',
    title: 'Resposta Rápida',
    desc: 'Tempo de resposta ágil para suporte emergencial. Seu negócio não pode esperar.',
  },
  {
    icon: 'ri-award-line',
    title: 'Qualidade Profissional',
    desc: 'Toda instalação segue padrões técnicos rigorosos, com documentação completa da infraestrutura.',
  },
  {
    icon: 'ri-team-line',
    title: 'Equipe Certificada',
    desc: 'Especialistas com certificações reconhecidas pelo mercado, garantindo entregas técnicas com qualidade e segurança.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-brand-bg py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-neon-green text-xs font-bold tracking-widest uppercase mb-3 block">
            Quem Somos
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Tecnologia que <span className="text-neon-green">transforma</span> negócios
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed">
            Somos a MRC TI, especialistas em infraestrutura de tecnologia para empresas de todos os portes.
            Nossa missão é manter sua operação sempre no ar, sem interrupções.
          </p>
        </div>

        {/* Two column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Image */}
          <div className="relative rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20IT%20technician%20team%20working%20in%20modern%20server%20room%2C%20organized%20cable%20management%20rack%2C%20network%20infrastructure%20setup%2C%20green%20LED%20lights%2C%20dark%20environment%2C%20corporate%20technology%20environment%2C%20close%20up%20detailed%20work%2C%20team%20collaboration&width=700&height=500&seq=about-mrc-ti&orientation=landscape"
              alt="Equipe MRC TI"
              className="w-full h-[360px] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/60 to-transparent" />
            {/* Badge overlay */}
            <div className="absolute bottom-6 left-6 bg-brand-bg/90 border border-neon-green/30 rounded-lg px-5 py-3">
              <div className="text-2xl font-extrabold text-neon-green">+100</div>
              <div className="text-gray-400 text-sm">Projetos Entregues</div>
            </div>
          </div>

          {/* Text */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              Infraestrutura sólida para empresas que não podem parar
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Desde redes Wi-Fi corporativas a servidores de alto desempenho, a MRC TI entrega projetos
              completos de infraestrutura de TI. Atuamos com planejamento, implantação e suporte contínuo,
              garantindo estabilidade e segurança para o seu negócio.
            </p>
            <p className="text-gray-400 leading-relaxed mb-8">
              Trabalhamos com empresas dos segmentos comercial, industrial e de serviços, sempre com
              foco em soluções duradouras e tecnologia de ponta.
            </p>
            <ul className="space-y-3">
              {[
                'Projetos customizados para cada cliente',
                'Especialistas certificados nas principais tecnologias de TI',
                'Suporte técnico especializado',
                'Garantia em todas as instalações',
                'Parceiro oficial das principais marcas do mercado',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-300 text-sm">
                  <i className="ri-checkbox-circle-fill text-neon-green mt-0.5" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {VALUES.map((v) => (
            <div
              key={v.title}
              className="bg-brand-card border border-brand-border rounded-xl p-6 hover:border-neon-green/40 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-neon-green/10 rounded-lg mb-4 group-hover:bg-neon-green/20 transition-colors">
                <i className={`${v.icon} text-neon-green text-xl`} />
              </div>
              <h4 className="text-white font-semibold text-sm mb-2">{v.title}</h4>
              <p className="text-gray-500 text-xs leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
